<template>
  <div v-if="user" class="md-layout md-gutter mt-4">
    <div v-show="loading" style="position:absolute;z-index:10;background-color: rgb(66 165 245 / 40%);display: flex; text-align: center;padding-top:60px;width:100%;height:100%">
      <p style="    margin: 0 auto;color: black;font-size: 32px;">Please, wait a moment...</p>
    </div>
      <div class="md-layout-item md-size-100 md-small-size-100 mt-4">
        <div class="md-layout-item md-size-100">
          <add-profile-card :user="user" :apiValidationErrors="apiValidationErrors"/>
        </div>
        <div class="md-layout-item md-size-100">
          <user-password-card :user="user" :apiValidationErrors="apiValidationErrors"/>
        </div>
        <md-card-actions>
          <md-button @click="submitUser">
            Save
          </md-button>
        </md-card-actions>
      </div>
    </div>
</template>
<script>
import AddProfileCard from "@/pages/Dashboard/Users/UserProfile/AddProfileCard.vue";
import UserPasswordCard from "@/pages/Dashboard/Users/UserProfile/AddPasswordCard.vue";
import formMixin from "@/mixins/form-mixin";

export default {

  components: {
    "add-profile-card": AddProfileCard,
    "user-password-card": UserPasswordCard
  },
  mixins: [formMixin],

  data: () => ({
        user: {name:"",phone:"",email:"",password:"",password_confirmation:""},
        loading:false
  }),

  methods: {
    async submitUser() {
      const user = {
        nombre: this.user.name,
        telefono: this.user.phone,
        email: this.user.email,
        password: this.user.password,
        password_confirmation: this.user.password_confirmation,
      }

      try {
        this.loading=true;
        await this.$store.dispatch("users/add", user)
        await this.$store.dispatch("alerts/success", "verification email sent.")
        this.loading=false;
      } catch (e) {
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.loading=false;
        this.setApiValidation(e.response.data.errors)
      }

    },
  },
};
</script>
